import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate environment is selected
  if (!properties.environment) {
    errors.push({
      key: 'environment',
      message: 'Environment is required',
    });
  }

  // Validate action is selected
  if (!properties.action) {
    errors.push({
      key: 'action',
      message: 'Action is required',
    });
  }

  // Validate action-specific required fields
  const action = properties.action;

  if (action === 'getMember' || action === 'updateMember') {
    if (!properties.memberId || properties.memberId.trim() === '') {
      errors.push({
        key: 'memberId',
        message: 'Member ID is required for this action',
      });
    }
  }

  if (action === 'updateMember') {
    if (!properties.memberData || properties.memberData.trim() === '') {
      errors.push({
        key: 'memberData',
        message: 'Member Data is required for Update Member action',
      });
    } else {
      // Validate JSON format
      try {
        JSON.parse(properties.memberData);
      } catch (e) {
        errors.push({
          key: 'memberData',
          message: 'Member Data must be valid JSON',
        });
      }
    }
  }

  if (action === 'updateTag') {
    if (!properties.tagId || properties.tagId.trim() === '') {
      errors.push({
        key: 'tagId',
        message: 'Tag ID is required for Update Tag action',
      });
    }
    if (!properties.tagData || properties.tagData.trim() === '') {
      errors.push({
        key: 'tagData',
        message: 'Tag Data is required for Update Tag action',
      });
    } else {
      // Validate JSON format
      try {
        JSON.parse(properties.tagData);
      } catch (e) {
        errors.push({
          key: 'tagData',
          message: 'Tag Data must be valid JSON',
        });
      }
    }
  }

  if (action === 'updateGroup') {
    if (!properties.groupId || properties.groupId.trim() === '') {
      errors.push({
        key: 'groupId',
        message: 'Group ID is required for Update Group action',
      });
    }
    if (!properties.groupData || properties.groupData.trim() === '') {
      errors.push({
        key: 'groupData',
        message: 'Group Data is required for Update Group action',
      });
    } else {
      // Validate JSON format
      try {
        JSON.parse(properties.groupData);
      } catch (e) {
        errors.push({
          key: 'groupData',
          message: 'Group Data must be valid JSON',
        });
      }
    }
  }

  // Validate query params format if provided
  if (properties.queryParams && typeof properties.queryParams === 'string') {
    const queryString = properties.queryParams.trim();
    if (queryString.length > 0) {
      // Basic validation: check for key=value format
      const params = queryString.split('&');
      for (const param of params) {
        if (!param.includes('=')) {
          errors.push({
            key: 'queryParams',
            message: 'Query parameters must be in format: key=value or key1=value1&key2=value2',
          });
          break;
        }
      }
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
